import {
  Alert,
  Box,
  Button,
  Divider,
  Grid2 as Grid,
  Paper,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import { handleRetrieveUserBookedWebinars } from "../../../../../redux/user-slices/webinar.slice";
import SkeletonImage from "../../../../../components/ui/SkeletonImage";
import { Link, Link as NavLink, useParams } from "react-router-dom";
import { FILE_PATH_URI } from "../../../../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { Fragment, useEffect, useState } from "react";
import moment from "moment";

function SpecialistBookedWebinars() {
  const { type } = useParams();
  const dispatch = useDispatch();
  const [data, setdata] = useState({});
  const { loadings, refresh } = useSelector((state) => state.otherSlice);

  // Handle get all blogs
  const handleretrieveAll = async () => {
    const response = await dispatch(
      handleRetrieveUserBookedWebinars({
        type,
      })
    ).unwrap();
    setdata(response);
  };

  useEffect(() => {
    handleretrieveAll();

    // eslint-disable-next-line
  }, [refresh, type]);

  return (
    <Fragment>
      <Box
        sx={{
          p: 1,
          mb: 3,
          gap: 1,
          display: "flex",
          border: "1px solid",
          borderRadius: "6px",
          alignItems: "center",
          borderColor: "divider",
        }}
      >
        {["past", "upcoming"]?.map((ele, i) => (
          <Button
            disableRipple
            LinkComponent={NavLink}
            key={`${ele}-${i + 1}`}
            to={`/specialist/profile/booked-webinar/${ele}`}
            sx={{
              textTransform: "capitalize",
              bgcolor: "transparent !important",
              color: type === ele ? "primary.main" : "other.color1",
            }}
          >
            {ele}
          </Button>
        ))}
      </Box>

      <Grid container spacing={2}>
        {loadings?.retrieveAll ? (
          new Array(4).fill().map((_, i) => (
            <Grid key={i} size={{ xs: 12, md: 6, xl: 4 }}>
              <Skeleton
                sx={{
                  width: "100%",
                  height: "100%",
                  transform: "none",
                  aspectRatio: "1/0.5",
                }}
              />
            </Grid>
          ))
        ) : data?.records?.length === 0 ? (
          <Grid size={12}>
            <Alert
              sx={{
                fontSize: "20px",
                fontWeight: "500",
                alignItems: "center",
                fontFamily: "Poppins",
                ".MuiAlert-message": { p: "0" },
                ".MuiAlert-icon": { fontSize: "28px" },
              }}
              color="error"
              severity="error"
            >
              No Records Found!
            </Alert>
          </Grid>
        ) : (
          data?.records?.map((element, i) => (
            <Grid key={i} size={{ xs: 12, md: 6, xl: 4 }}>
              <Paper
                sx={{
                  p: 2,
                  gap: 1,
                  height: "100%",
                  display: "flex",
                  borderRadius: "6px",
                  border: "1px solid",
                  borderColor: "divider",
                  flexDirection: "column",
                  transition: "all 450ms ease",
                  boxShadow: "0 0 10px 0 #0000000a",
                  ":hover": {
                    transform: "scale(1.01)",
                    boxShadow: "0 0 10px 0 #00000021",
                  },
                }}
              >
                <Box
                  component={Link}
                  to={`/webinar/${element._id}`}
                  sx={{
                    width: "100%",
                    overflow: "hidden",
                    borderRadius: "6px",
                    aspectRatio: "1/0.6",
                  }}
                >
                  <SkeletonImage
                    src={FILE_PATH_URI + element?.details?.coverImage?.path}
                  />
                </Box>

                <Stack spacing={2} sx={{ flexGrow: 1 }}>
                  <Divider />
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography>
                      {element?.seats?.booked || 0} seats booked
                    </Typography>

                    {type === "past" &&
                      element?.resources?.files?.[0]?.path && (
                        <Typography
                          variant="body2"
                          color="success.main"
                          fontWeight="500"
                          sx={{
                            bgcolor: "#e0ffe1",
                            p: "4px 8px",
                            borderRadius: "4px",
                            width: "fit-content",
                            fontSize: "13px",
                            textDecoration: "none",
                          }}
                          component={Link}
                          to={`/webinar/${element._id}`}
                        >
                          Resources Available
                        </Typography>
                      )}
                    <Button
                      size="small"
                      variant="outlined"
                      LinkComponent={NavLink}
                      sx={{ py: 0 }}
                      to={`/specialist/profile/bookings/${element?._id}`}
                    >
                      View all
                    </Button>
                  </Box>
                  <Typography
                    fontSize={20}
                    fontWeight="500"
                    color="other.color1"
                    component={Link}
                    sx={{ textDecoration: "none" }}
                    to={`/webinar/${element._id}`}
                  >
                    {element?.details?.title}
                  </Typography>
                  <Typography
                    lineHeight="1"
                    fontWeight="500"
                    component="span"
                    mt="4px !important"
                    color="other.color2"
                  >
                    {moment(element?.schedule?.startTime).format(
                      "MMM DD YYYY [at] hh:mm A"
                    )}
                  </Typography>
                </Stack>
              </Paper>
            </Grid>
          ))
        )}
      </Grid>
    </Fragment>
  );
}

export default SpecialistBookedWebinars;
